import React from 'react';
import { Form, Input, InputNumber, Switch, DatePicker, FormInstance } from 'antd';
import moment from 'moment';
import { DetailDefinition } from '../../types';

interface DynamicDetailFormProps {
    definitions: DetailDefinition[];
    initialValues: Record<string, any>;
    onFinish?: (values: any) => void;
    formInstance?: FormInstance;
}

const DynamicDetailForm: React.FC<DynamicDetailFormProps> = ({ 
    definitions, 
    initialValues, 
    onFinish,
    formInstance
}) => {
    const [form] = Form.useForm();
    const activeForm = formInstance || form;

    // Используем useEffect для обновления значений формы при смене initialValues
    React.useEffect(() => {
        const processedValues = { ...initialValues };
        definitions.forEach(def => {
            if (def.valueType === 'date' && initialValues[def.code]) {
                processedValues[def.code] = moment(initialValues[def.code]);
            }
        });
        activeForm.setFieldsValue(processedValues);
    }, [initialValues, definitions, activeForm]);

    const renderField = (def: DetailDefinition) => {
        switch (def.valueType) {
            case 'number':
                return <InputNumber style={{ width: '100%' }} placeholder={def.description || ''} />;
            case 'boolean':
                return <Switch />;
            case 'date':
                return <DatePicker style={{ width: '100%' }} format="DD.MM.YYYY" />;
            case 'json':
                return <Input.TextArea rows={4} placeholder="Введите JSON" />;
            case 'string':
            default:
                return <Input placeholder={def.description || ''} />;
        }
    };

    return (
        <Form
            form={activeForm}
            layout="vertical"
            onFinish={onFinish}
        >
            {definitions.map(def => (
                <Form.Item
                    key={def.code}
                    name={def.code}
                    label={def.name}
                    tooltip={def.description}
                    rules={[{ required: def.isRequired, message: `Поле ${def.name} обязательно` }]}
                    valuePropName={def.valueType === 'boolean' ? 'checked' : 'value'}
                >
                    {renderField(def)}
                </Form.Item>
            ))}
        </Form>
    );
};

export default DynamicDetailForm;
